import React, { useEffect, useState, createContext, useContext } from "react";

type MyContextValue = {
  winHeight: number;
  setHeight: (hg?: number) => void;
};
const MyWinHeightContext = createContext<MyContextValue | undefined>(undefined);
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height1 } = window;
  const contentElement = document.getElementById("alart-dynamic-content");
  let heightOfAlart = 0;
  if (contentElement) {
    heightOfAlart = contentElement.offsetHeight - 17;
  }
  const height = height1 - heightOfAlart;
  return {
    width,
    height,
  };
};
export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
export const WindowDimensions: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [winHeight, setWinHeight] = useState<number>(0);

  const setHeight = (hg?: number) => {
    if (hg) {
      setWinHeight(hg);
    } else {
      const { height } = getWindowDimensions();
      setWinHeight(height);
    }
  };

  useEffect(() => {
    function handleResize() {
      setHeight();
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const contextValue: MyContextValue = {
    winHeight,
    setHeight,
  };
  return <MyWinHeightContext.Provider value={contextValue}>{children}</MyWinHeightContext.Provider>;
};

export const useMyWinHeightContext = () => {
  const context = useContext(MyWinHeightContext);
  if (!context) {
    throw new Error("useMyContext must be used within a MyContextProvider");
  }
  return context;
};
